import { Component, OnInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core'
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router'
import { filter, map, mergeMap } from 'rxjs/operators'
import { AuthService } from '../../services/auth.service'
import { UtilitiesService } from '../../services/utilities.service'

@Component({
    selector: 'ui-layout',
    templateUrl: './default-layout.component.html',
    styleUrls: ['./default-layout.component.css'],
})
export class DefaultLayoutComponent implements OnInit {
    public sidebarShowMobile = false
    public sidebarShowLG = true
    sidebarBackdrop: boolean
    // internaltest = window.location.hostname.indexOf('internaltest') >= 0
    internaltest = true
    @Input()
    public sideBarMenuItems
    @Input() currentComponent: any
    breadcrumbActionFromChild: any
    // @ViewChild('dropdownMenu', { read: ElementRef, static: false }) dropdownMenu: ElementRef

    constructor(
        private router: Router,
        private authService: AuthService,
        private route: ActivatedRoute,
        private utilitiesService: UtilitiesService
    ) {}

    onMenuClick(event: Event) {
        if (this.sidebarBackdrop) {
            this.toggleMinimize(event)
        }
    }

    @HostListener('document:click', ['$event'])
    documentClick(event: any): void {
        this.utilitiesService.documentClickedTarget.next(event.target)
    }

    toggleMinimize(e) {
        this.sidebarShowMobile = !this.sidebarShowMobile
        this.sidebarBackdrop = this.sidebarShowMobile
    }
    toggleSidebarLG(e: Event) {
        this.sidebarShowLG = !this.sidebarShowLG
        this.sidebarBackdrop = this.sidebarShowMobile
    }
    backdropClick(event: Event) {
        this.toggleMinimize(!this.sidebarShowMobile)
    }
    documentClickListener(target: any): void {
        // if (this.dropdownMenu.nativeElement.contains(target)) {
        //     // Clicked inside
        //     this.dropdownMenu.nativeElement.classList.add('show')
        // } else {
        // }
    }
    ngOnInit() {
        this.utilitiesService.documentClickedTarget.subscribe((target) => this.documentClickListener(target))
        // this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event: Event) => {})

        // this.route.data.subscribe(data => {
        //     console.log(`Route change: shell ${data.shell}`)
        //     this.shell = !(data.shell === false)
        // })
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (this.currentComponent) {
                console.log(
                    `in container actin template: ${this.currentComponent.constructor.name} ${this.currentComponent.breadcrumbAction}`
                )
                this.breadcrumbActionFromChild = this.currentComponent.breadcrumbAction
            }
        })
    }

    logout(event: Event) {
        this.authService.logout().subscribe((_) => this.router.navigate(['/login']))
    }
}
